




























import VueOptions from '@utils/VueOptions'
import WizardNavbar from '@ui/AudienceCreativeWizard/WizardNavbar'
import WizardNavigation from '@ui/AudienceCreativeWizard/WizardNavigation'
import CreativeForm from '@ui/AudienceCreativeWizard/Forms/CreativeForm'
import Modal from '@components/Modal'

settings =
  name: 'CreativeStep'

  vue:
    props: ['wizard', 'step']

    components: {
      WizardNavbar,
      WizardNavigation,
      CreativeForm,
      Modal,
    }

    data: ->
      requiredFieldsModal:
        show: false

    computed:
      form: ->
        data: @wizard.audienceCreativeData
        errors: @wizard.audienceCreativeErrors

      missingRequiredFields: ->
        fields = []
        fields.push 'Title' unless @form.data?.title?.length
        fields.push 'Experience Types' unless @form.data?.primary_type
        fields

    methods:
      hiConfirmModal: (stepName) ->
        if @missingRequiredFields.length
          @requiredFieldsModal.show = true
          return

export default VueOptions.vue settings
